import React from 'react';
import { Route, Routes } from 'react-router-dom';
import LoginPage from './components/pages/LoginPage';
import ApplicationBasePage from './components/pages/ApplicationBasePage';
import NotFoundPage from './components/pages/NotFoundPage';
import AuthRoute from './common/route-guards/AuthRoute';
import AcceptInvitationPage, {
  AcceptInvitationRequestType,
} from './components/pages/AcceptInvitationPage';
import SetPasswordPage from './components/pages/SetPasswordPage';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { useAppSelector } from './redux/hooks';
import { getAuthenticatedLandingPath } from './common/route-guards/authenticated-landing-path';

const AppRoutes = () => {
  const selectedRole = useAppSelector((state) => state.user.selectedRole);
  const selectedClinicRole = useAppSelector(
    (state) => state.user.selectedClinicRole
  );
  const authenticatedLandingPath = getAuthenticatedLandingPath(
    selectedRole,
    selectedClinicRole
  );

  return (
    <QueryParamProvider adapter={ReactRouter6Adapter}>
      <Routes>
        <Route
          path="/login/*"
          element={
            <AuthRoute
              type="public"
              permissions={['none']}
              redirectPath={authenticatedLandingPath}
            >
              <LoginPage />
            </AuthRoute>
          }
        />

        <Route
          path="/set-password/:token/*"
          element={
            <AuthRoute type="public" permissions={['none']}>
              <SetPasswordPage />
            </AuthRoute>
          }
        />

        <Route
          path="/providers/approve/:token/*"
          element={
            <AuthRoute type="public" permissions={['none']}>
              <AcceptInvitationPage
                acceptInvitationRequestType={
                  AcceptInvitationRequestType.CLINIC_LOCATION_PROVIDER
                }
              />
            </AuthRoute>
          }
        />

        <Route
          path="/patients/approve/:token/*"
          element={
            <AuthRoute type="public" permissions={['none']}>
              <AcceptInvitationPage
                acceptInvitationRequestType={
                  AcceptInvitationRequestType.CLINIC_LOCATION_PATIENT
                }
              />
            </AuthRoute>
          }
        />

        <Route
          path="/provider-patients/approve/:token/*"
          element={
            <AuthRoute type="public" permissions={['none']}>
              <AcceptInvitationPage
                acceptInvitationRequestType={
                  AcceptInvitationRequestType.PROVIDER_PATIENT
                }
              />
            </AuthRoute>
          }
        />

        <Route path="/page-not-found" element={<NotFoundPage />} />

        <Route
          path="/*"
          element={
            <AuthRoute
              type="protected"
              permissions={['user']}
              redirectPath="/login"
            >
              <ApplicationBasePage />
            </AuthRoute>
          }
        />
      </Routes>
    </QueryParamProvider>
  );
};

export default AppRoutes;
